import { FieldType, FormType } from "@/enums";
import { useGetAdminFlatFormsQuery } from "@/services";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

export const useFlatFormAvailability = (id) => {
  const intl = useIntl();

  const [availableParent, setAvailableParent] = useState();
  const [availableDateFields, setAvailableDateFields] = useState([]);

  const { data: { flatForms } = {} } = useGetAdminFlatFormsQuery();

  useEffect(() => {
    const getAvailableDateFields = (id) => {
      const fieldIdsDoNotMatch = ({ property }) => !id || property.id !== id;

      return flatForms
        .filter(
          (field) =>
            field.property.target === FormType.Intake &&
            field.property.fieldType === FieldType.Date &&
            fieldIdsDoNotMatch(field)
        )
        .map(({ property: { label, name } }) => ({
          label: intl.formatMessage({
            id: label.id,
            defaultMessage: label.fallback,
          }),
          value: name,
        }));
    };

    const getAvailableParent = () => {
      const fields = flatForms?.map(({ property: { label, id, target } }) => ({
        text: intl.formatMessage({
          id: label.id,
          defaultMessage: label.fallback,
        }),
        value: id,
        group: target.toLowerCase(),
      }));

      return {
        key: FormType.Intake,
        items: _.groupBy(fields, "group")[FormType.Intake] || [],
      };
    };

    if (!flatForms?.length) return;

    setAvailableDateFields(getAvailableDateFields(id));
    setAvailableParent(getAvailableParent());
  }, [flatForms, id, intl]);

  return { availableParent, availableDateFields };
};
